export const getOnBoarding = () => {
    const query = `
        query{
            onBoardingStats
        }
    `;
    return query;
}

export const declineOnboarding = () => {
    const mutation =`
        mutation {
            declineOnboarding {
                success
                errors
            }
        }
    `
    return mutation;
}